const INFOR_USER = {
  INFOR_USER: 'infor'
};

export default INFOR_USER;
